import React from 'react';
import { type GridColDef } from '@mui/x-data-grid-premium';

import { useSettings } from 'app/main/components';
import { ViewTable, ViewTableUtils } from 'app/main/components/page-layouts';
import { LineTotalCell, LinesTableFooterInfo } from 'app/main/modules/components/LinesTableUtils';

interface ErpOrdersLinesTabProps {
	orderErpId: string;
	refresh: boolean;
	updateRefresh: () => void;
}

export default function ErpOrdersLinesTab(props: ErpOrdersLinesTabProps) {
	const { t } = useSettings();

	const columns: GridColDef[] = [
		{
			field: 'orli_item_erp_id',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_ERP_ID'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderCellWithTooltip
		},
		{
			field: 'orli_description',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_DESCRIPTION'),
			minWidth: 400,
			flex: 4,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderCellWithTooltip({
					value: row.orli_item_erp_id ? value : <i>{value}</i>,
					to: { module: 'items', uid: row.orli_item_uid }
				}),
			hideable: false
		},
		{
			field: 'orli_quantity',
			type: 'number',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_QUANTITY'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			hideable: false
		},
		{
			field: 'orli_base_price',
			type: 'number',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_BASE_PRICE'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderCurrency
		},
		{
			field: 'orli_discount',
			type: 'number',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_DISCOUNT'),
			minWidth: 100,
			renderCell: ViewTableUtils.renderPercentage
		},
		{
			field: 'orli_unit_price',
			type: 'number',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_UNIT_PRICE'),
			minWidth: 125,
			renderCell: ViewTableUtils.renderCurrency,
			hideable: false
		},
		{
			field: 'orli_tot_value_tax_excl',
			type: 'number',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_TOT_TAX_EXCL'),
			minWidth: 125,
			renderCell: ({ value, row }) => <LineTotalCell price={value} isGift={row.orli_gift} />,
			hideable: false
		},
		{
			field: 'orli_tot_value_tax_incl',
			type: 'number',
			headerName: t('DETAILS_ERP_ORDERS_LINES_FIELD_TOT_TAX_INCL'),
			minWidth: 125,
			renderCell: ({ value, row }) => <LineTotalCell price={value} isGift={row.orli_gift} />,
			hideable: false
		}
	];

	return (
		<ViewTable
			module="erp_orders_lines"
			columns={columns}
			defaultFilters={[
				{
					filt_field: 'orli_ords_erp_id',
					filt_clause: 'equals',
					filt_value: props.orderErpId
				}
			]}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
			showExportButton={false}
			slots={{
				footerCustomInfo: ({ additionalInfo }) => (
					<LinesTableFooterInfo
						totTaxExcl={additionalInfo.tot_value_tax_excl}
						totTaxIncl={additionalInfo.tot_value_tax_incl}
					/>
				)
			}}
		/>
	);
}
